import { render, staticRenderFns } from "./publicItem.vue?vue&type=template&id=7bbae9c4&scoped=true&"
import script from "./publicItem.vue?vue&type=script&lang=js&"
export * from "./publicItem.vue?vue&type=script&lang=js&"
import style0 from "./publicItem.vue?vue&type=style&index=0&id=7bbae9c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbae9c4",
  null
  
)

export default component.exports